export function formatSpeciesLabel(species: string): string {
  if (species === "DOG") return "Dog";
  if (species === "CAT") return "Cat";
  return species;
}

export function getScoreBandColor(scoreBand: string | null): string {
  switch (scoreBand) {
    case "GREEN":
      return "bg-success/10 text-success border-success/20";
    case "YELLOW":
      return "bg-warning/10 text-warning border-warning/20";
    case "RED":
      return "bg-destructive/10 text-destructive border-destructive/20";
    default:
      return "bg-muted text-muted-foreground";
  }
}
